/**
 * Created by vladislav on 09.08.2022
 */

const TravelBook = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.TRAVEL_BOOK) || {};

    this.lastForce = data.force || 0;

    this.pages = [new ExpeditionPage(`${cleverapps.meta.getMainLocationId()}`)];
};

TravelBook.prototype.save = function () {
    cleverapps.dataLoader.save(DataLoader.TYPES.TRAVEL_BOOK, {
        force: this.lastForce
    });
};

TravelBook.prototype.init = function () {
    const pages = cleverapps.meta.listAvailableLocations().filter((locationId) => locationId !== "main")
        .map((locationId) => this.getPageById(locationId) || new ExpeditionPage(locationId));

    const main = this.pages.find((page) => page.isMain);

    this.pages = [main].concat(pages);

    this.updatePages();
};

TravelBook.prototype.listAllPages = function () {
    return this.pages;
};

TravelBook.prototype.listDisplayedPages = function () {
    const getOrder = function (page) {
        if (page.isPermanent()) {
            return 100;
        }
        return 1;
    };

    const expeditions = this.pages.filter((page) => !page.isMain && page.isActive()).sort((a, b) => getOrder(b) - getOrder(a));

    const main = this.pages.find((page) => page.isMain);
    let pages = [main].concat(expeditions);

    if (pages.length < TravelBook.DISPLAYED_PAGES) {
        pages = pages.concat(this.listUpcoming().slice(0, TravelBook.DISPLAYED_PAGES - pages.length));
    }

    return pages;
};

TravelBook.prototype.getPageById = function (id) {
    return this.pages.find((page) => page.id === id);
};

TravelBook.prototype.getCurrentPage = function () {
    const location = cleverapps.meta.getSelectedLocation();
    return this.getPageById(location.locationId);
};

TravelBook.prototype.listAvailablePages = function () {
    return this.pages.filter((page) => !page.available || cleverapps.user.checkAvailable(page.available));
};

TravelBook.prototype.updatePages = function () {
    this.pages.forEach((page) => {
        page.checkFullLives();
        page.updateState();
    });

    this.updateSchedulePushes();
};

TravelBook.prototype.updateSchedulePushes = function () {
    const eligible = (page) => !page.isMain && (!page.available || cleverapps.user.checkAvailable(page.available));

    const upcoming = this.pages.filter((page) => eligible(page))
        .map((page) => cleverapps.meta.getLocationMeta(page.id))
        .filter((meta) => meta.getTimeToNextStart() !== undefined && meta.getTimeToNextStart() > 0)
        .sort((a, b) => a.getTimeToNextStart() - b.getTimeToNextStart())[0];

    if (upcoming) {
        PushHelper.sendPush(PUSHES.EXPEDITION_NEW, upcoming.getTimeToNextStart());
    } else {
        PushHelper.cancelPush(PUSHES.EXPEDITION_NEW);
    }

    const ending = this.pages.filter((page) => eligible(page) && page.isActive())
        .map((page) => cleverapps.meta.getLocationMeta(page.id))
        .filter((meta) => meta.getTimeLeft() > TravelBook.EXPEDITION_END_TIMEOUT)
        .sort((a, b) => a.getTimeLeft() - b.getTimeLeft())[0];

    if (ending) {
        PushHelper.sendPush(PUSHES.EXPEDITION_END, ending.getTimeLeft() - TravelBook.EXPEDITION_END_TIMEOUT);
    } else {
        PushHelper.cancelPush(PUSHES.EXPEDITION_END);
    }
};

TravelBook.prototype.onUpdateExpedition = function () {
    this.updateBuilt();
    this.getCurrentPage().setNew(false);
};

TravelBook.prototype.startNewExpedition = function (locationMeta) {
    const newPage = this.getPageById(locationMeta.locationId);

    this.pages.filter((page) => page.slot === newPage.slot).forEach((page) => {
        page.resetEvents();
    });

    newPage.setNew(true);
    newPage.setAttentionEvent(ExpeditionPage.EVENT_START);
    newPage.resetIntroWindowShown();

    cleverapps.forces.clearForce(Forces.TRAVEL_BOOK);

    this.updatePages();
};

TravelBook.prototype.updateBuilt = function () {
    const page = this.getCurrentPage();

    const worker = Map2d.currentMap.workers && Map2d.currentMap.workers.findLeastBusy(Buildable);
    if (worker) {
        const timeReady = Date.now() + worker.getTimeLeft();

        page.planEvent(ExpeditionPage.EVENT_BUILT, timeReady);
        page.setAttentionEvent(ExpeditionPage.EVENT_BUILT);
    } else {
        page.planEvent(ExpeditionPage.EVENT_BUILT, 0);
    }
};

TravelBook.prototype.listUpcoming = function () {
    const activeSlots = this.pages.filter((page) => page.isActive()).map((page) => page.slot);
    const upcoming = this.pages.filter((page) => page.isUpcoming() && !activeSlots.includes(page.slot));

    const permanent = upcoming.find((page) => page.isPermanent());
    const regulars = upcoming.filter((page) => !page.isPermanent());

    // at most one regular; one-shots fill the remaining slots, listDisplayedPages caps the total
    return [permanent].filter(Boolean).concat(regulars);
};

TravelBook.prototype.needsAttention = function () {
    return this.pages.some((page) => page.attention);
};

TravelBook.prototype.markForceShown = function () {
    this.lastForce = Date.now();
    this.save();
};

TravelBook.prototype.chooseForce = function () {
    const pages = this.listDisplayedPages().filter((page) => page.isActive() && !page.isMain).sort((page1, page2) => page2.getStartTime() - page1.getStartTime());

    if (!pages.length) {
        return;
    }

    const hasIntro = (page) => typeof ExpeditionIntroWindow !== "undefined" && ExpeditionIntroWindow.hasIntro(page);

    let selectedForce;
    let selectedPage = pages.find((page) => page.isNew);
    if (selectedPage && !hasIntro(selectedPage) && !cleverapps.forces.isShown(Forces.TRAVEL_BOOK) && cleverapps.meta.listPendingLocations().length === 0) {
        selectedForce = cleverapps.clone(Forces.TRAVEL_BOOK, true);
        selectedForce.text = selectedPage.forceText;
        selectedForce.page = selectedPage.id;
        return selectedForce;
    }

    if (this.lastForce + TravelBook.FORCE_TIMEOUT > Date.now()) {
        return;
    }

    selectedPage = pages.find((page) => !page.isPermanent() && page.isCompleted());
    if (selectedPage) {
        selectedForce = cleverapps.clone(Forces.TRAVEL_BOOK_HINT, true);
        selectedForce.text = () => Messages.get("ExpeditionProgressHint.completed", { name: Messages.get(selectedPage.title) });
        selectedForce.page = selectedPage.id;
        return selectedForce;
    }

    selectedPage = pages.find((page) => !page.isPermanent() && page.getTimeLeft() < cleverapps.parseInterval("3 day"));
    if (selectedPage) {
        selectedForce = cleverapps.clone(Forces.TRAVEL_BOOK_HINT, true);
        selectedForce.text = () => Messages.get("ExpeditionProgressHint.remaining", { name: Messages.get(selectedPage.title), remaining: Math.ceil(selectedPage.getTimeLeft() / cleverapps.parseInterval("1 day")) });
        selectedForce.page = selectedPage.id;
        return selectedForce;
    }
};

TravelBook.DISPLAYED_PAGES = 4;
TravelBook.FORCE_TIMEOUT = cleverapps.parseInterval("1 day");
TravelBook.EXPEDITION_END_TIMEOUT = cleverapps.parseInterval("2 days");
